import { cloneDeep as _cloneDeep, includes as _includes, map as _map } from 'lodash';

import { type Form, type Pass } from '@sine/sine-core-api-types';

import { FieldType } from '../../../services/form/constants';
import formService from '../../../services/form/form.service';
import type { FormWithResponses } from '../../../services/form/signin.types';
import type { PrePass } from '../components/visitorCheckInModal.types';

export function applyValuesToSiteForm(form: FormWithResponses, values: any) {
  const siteForm = _cloneDeep(form);

  siteForm.fields.forEach((field) => {
    switch (field.type) {
      case FieldType.MULTIPLE_CHOICE:
        field.value = values[field.id]?.label;
        break;
      case FieldType.SELECTIVE_CHOICE:
        field.value = values[field.id];
        field.mappedOptions = _map(field.options, (option, index) => {
          return {
            name: option,
            selected: false,
            required: _includes(field.allowedOptions, index),
            hasError: false,
          };
        });
        break;
      case FieldType.TEXT:
      case FieldType.SIGNATURE:
      case FieldType.NUMBER:
      case FieldType.BOOLEAN_SWITCH:
        field.value = values[field.id];
        break;
    }

    return field;
  });

  return siteForm;
}

export function applyFormResponseToPass<T extends PrePass | Pass>(form: Form, values: any, pass: T): T {
  const siteForm = applyValuesToSiteForm(form, values);

  const passWithFormResponses = _cloneDeep(pass);

  const fieldErrors = formService.validateFormResponse(passWithFormResponses, siteForm.fields);

  if (fieldErrors) {
    const message = `Your form response has been rejected. The following errors have been found:`;

    const messageHtml = `
          ${message}<br><br>
          ${fieldErrors.join('<br>')}
      `;

    throw messageHtml;
  }

  passWithFormResponses.formResponses = {
    id: siteForm.id,
    responses: formService.serializeFormResponses(siteForm.fields),
  };

  return passWithFormResponses;
}
